import { useState } from 'react';

import useCustomBack from '@/components/fakeDoor/hooks/useCustomBack';
import ArrowIcon from '../arrowIcon';
import { resolvePath } from '@/utils/resolvePath';

import Cookies from 'js-cookie';
import { getGarageFromPincode } from '@/components/fakeDoor/api';
import { getGarageRoutePath } from '@/components/fakeDoor/utils';
import { ROUTEMAP } from '@/components/fakeDoor/constants';
import Router from '@/components/common/router';
import { useRouter } from 'next/router';
import PincodeModal from '../pincodeModal';

type IBackButtonProps = {
    color?: string;
    garageName?: string;
    backUrl?: string;
    close?: boolean;
};

const BackButton = ({
    color = 'white',
    garageName,
    backUrl,
    close,
}: IBackButtonProps) => {
    const router = useRouter();
    const [showPincodeModal, setShowPincodeModal] = useState(false);

    const { closeWebView } = useCustomBack(close, backUrl);
    const isWebView = Boolean(Cookies.get('webview'));

    const handleClick = () => {
        if (isWebView && backUrl === '/') {
            closeWebView();
        } else if (close) {
            window.location.href = '/';
        } else {
            window.history.back();
        }

        //window.location.href = '/';
    };

    const ctaHandler = async (
        pincode: string,
        currentGarageId: string = ''
    ) => {
        // trackEventAPI({
        //     event_name: TAP_BTN_PINCODE_CONFIRM,
        //     customAttributes: {
        //         pincode: pincode,
        //     },
        //     isFakeDoor: true,
        // });
        if (pincode === localStorage.getItem('pincode')) {
            setShowPincodeModal(false);
            return;
        }

        const res = await getGarageFromPincode(pincode as string);
        if (currentGarageId === res?.id) {
            setShowPincodeModal(false);
            return;
        }
        localStorage.setItem('pincode', pincode);
        localStorage.setItem('garage_id', res?.id);
        const redURL = res?.id
            ? getGarageRoutePath(res.id.toLowerCase())
            : `${ROUTEMAP.GARAGE_COMING_SOON}?pincode=${pincode}`;

        console.log('redURL', redURL);
        Router.replace(redURL);
    };

    const handleLocationClick = () => {
        console.log(router.pathname);
        if (router.pathname.includes('service-center')) {
            setShowPincodeModal(true);
        }
    };

    return (
        <>
            <div className="back-container">
                <div></div>
                <ArrowIcon
                    direction="left"
                    size={24}
                    color={color}
                    clickHandler={handleClick}
                />

                {garageName && (
                    <div className="location" onClick={handleLocationClick}>
                        <div className="icon">
                            {' '}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="16"
                                viewBox="0 0 12 16"
                                fill="none"
                            >
                                <path
                                    d="M6.1093 7.7767C6.94294 7.7767 7.61874 7.1009 7.61874 6.26726C7.61874 5.43361 6.94294 4.75781 6.1093 4.75781C5.27565 4.75781 4.59985 5.43361 4.59985 6.26726C4.59985 7.1009 5.27565 7.7767 6.1093 7.7767Z"
                                    fill="white"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M6.1091 2.20194C5.52726 2.20194 4.95115 2.31665 4.41373 2.53953C3.87632 2.76241 3.3881 3.08911 2.97704 3.50089C2.56601 3.91265 2.2402 4.40144 2.01825 4.93927C1.79631 5.47709 1.68261 6.05338 1.68364 6.6352L1.68364 6.63634C1.68364 8.64661 2.82311 10.4457 4.04991 11.7892C4.65545 12.4523 5.26283 12.9829 5.71906 13.3475C5.86932 13.4676 6.00263 13.5693 6.11338 13.6513C6.22324 13.5716 6.35516 13.473 6.5037 13.3565C6.95909 12.9992 7.56547 12.4775 8.17004 11.8207C9.39313 10.4921 10.5346 8.69284 10.5346 6.63634H11.1783L10.5346 6.6352C10.5356 6.0534 10.4219 5.4771 10.1999 4.93927C9.97797 4.40144 9.65217 3.91265 9.24113 3.50089C8.83007 3.08911 8.34185 2.76241 7.80444 2.53953C7.26702 2.31664 6.69093 2.20194 6.1091 2.20194ZM11.8224 6.63677C11.8237 5.88587 11.6769 5.14211 11.3904 4.44799C11.1039 3.75366 10.6833 3.12263 10.1526 2.59102C9.62194 2.05944 8.99166 1.63766 8.29781 1.3499C7.60396 1.06214 6.86022 0.914061 6.1091 0.914063C5.35799 0.914061 4.61421 1.06214 3.92036 1.3499C3.22652 1.63766 2.59623 2.05944 2.06557 2.59102C1.5349 3.12263 1.11428 3.75366 0.827758 4.44799C0.541295 5.14217 0.394511 5.88598 0.39576 6.63692C0.395976 9.1246 1.79109 11.2255 3.09889 12.6576C3.76069 13.3823 4.42067 13.9585 4.91496 14.3535C5.16259 14.5515 5.36991 14.705 5.51682 14.81C5.5903 14.8625 5.64877 14.903 5.68972 14.9309C5.71019 14.9448 5.7263 14.9556 5.73772 14.9632C5.74343 14.967 5.74797 14.97 5.7513 14.9722L5.75538 14.9749L5.75674 14.9758L5.75724 14.9761C5.75744 14.9762 5.75763 14.9763 6.1091 14.4368L5.75763 14.9763C5.96884 15.1139 6.24091 15.1156 6.45382 14.9807L6.1091 14.4368C6.45382 14.9807 6.45401 14.9806 6.45422 14.9804L6.45613 14.9792L6.46027 14.9766C6.46364 14.9744 6.46822 14.9715 6.47397 14.9677C6.48547 14.9603 6.50166 14.9497 6.52222 14.936C6.56334 14.9087 6.62198 14.8691 6.69565 14.8177C6.84292 14.7148 7.05064 14.5643 7.29869 14.3697C7.79381 13.9812 8.45478 13.4129 9.11756 12.693C10.4291 11.2683 11.8223 9.16753 11.8224 6.63677Z"
                                    fill="white"
                                />
                            </svg>
                        </div>

                        <div className="garage-name">{garageName}</div>
                    </div>
                )}
            </div>
            {showPincodeModal && (
                <PincodeModal
                    ctaHandler={ctaHandler}
                    showModal={showPincodeModal}
                    closeModal={() => setShowPincodeModal(false)}
                    type={'edit'}
                />
            )}
            <style jsx>{`
                .back-container {
                    display: flex;
                    position: fixed;
                    left: 10px;
                    top: 10px;
                    //transform: rotate(180deg) scale(1.4);
                }
                .location {
                    display: flex;
                    position: fixed;
                    right: 10px;
                    top: 10px;
                    gap: 2px;
                }
                .garage-name {
                    font-size: 12px;
                    font-weight: 400;
                    color: white;
                    margin: 0 4px 0 4px;
                }
                .icon {
                    //height: 20px;
                    //width: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            `}</style>
        </>
    );
};
export default BackButton;
